import { http } from "@/http/http.js";
export default {
  urlDirect(params) {
    return http.post("/web/azl/urlDirect", params);
  },
};
